import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { defer, filter, takeUntil } from 'rxjs';
import { environment } from '@environments/environment';
import { OrganizationContextService } from './organization-context.service';
import { MsalService } from '@azure/msal-angular';

/** Runs outside MSAL so even requests waiting for a token keep their original generation. */
export const organizationContextInterceptor: HttpInterceptorFn = (request, next) => {
  const context = inject(OrganizationContextService);
  const scoped =
    request.url.startsWith(environment.baseUrl) ||
    request.url.startsWith('https://graph.microsoft.com/') ||
    request.url.startsWith('https://management.azure.com/');
  if (!scoped) return next(request);
  const msal = inject(MsalService);
  return defer(() => {
    // Seed a restored session before its first scoped request. Without an explicit
    // tenant, discovery stays in bootstrap and MSAL retains its existing policy.
    context.restoreSession(msal.instance.getAllAccounts(), msal.instance.getActiveAccount());
    context.assertRequestAllowed();
    const generation = context.snapshot.generation;
    return next(request).pipe(
      takeUntil(context.invalidated$),
      filter(() => context.snapshot.generation === generation),
    );
  });
};
